import { Pipe, PipeTransform } from '@angular/core';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Pipe({
  name: 'tokenVaultActionDisplay',
  standalone: true,
})
export class TokenVaultActionDisplayPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    return CoreNiceLabelUtils.tokenVaultAction(value);
  }
}
